export const Roles = {
  USER: "USER",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN",
  DISPATCHER: "DISPATCHER",
  DRIVER: "DRIVER",
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];

/** i18n key mapping for role display names */
export const ROLE_I18N_KEYS: Record<RoleName, string> = {
  [Roles.USER]: "users.role.USER",
  [Roles.ADMIN]: "users.role.ADMIN",
  [Roles.SUPERADMIN]: "users.role.SUPERADMIN",
  [Roles.DISPATCHER]: "users.role.DISPATCHER",
  [Roles.DRIVER]: "users.role.DRIVER",
};

/** Roles shown in the create/edit user role picker: damis has no plain users to create, drivers come from the Drivers page */
export const ASSIGNABLE_ROLES: RoleName[] = [Roles.ADMIN, Roles.DISPATCHER];

/** Roles that can access admin pages (users, activity history) */
export const ADMIN_PAGE_ROLES: RoleName[] = [Roles.ADMIN, Roles.SUPERADMIN];

/** Default role for new admin-created users */
export const DEFAULT_NEW_USER_ROLE: RoleName = Roles.DISPATCHER;
